import { render, staticRenderFns } from "./Encuentro_data.vue?vue&type=template&id=5278e56d&scoped=true&"
import script from "./Encuentro_data.vue?vue&type=script&lang=js&"
export * from "./Encuentro_data.vue?vue&type=script&lang=js&"
import style0 from "./Encuentro_data.vue?vue&type=style&index=0&id=5278e56d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5278e56d",
  null
  
)

export default component.exports